module.exports = __webpack_public_path__ + "img/banner2.1898b8cf.jpg";